import { Expose } from "class-transformer";
import { IsBoolean, IsString } from "class-validator";

export class User {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  userName!: string;
  @IsBoolean()
  @Expose()
  isApproved!: boolean;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}
